import { useState, useEffect, useCallback } from 'react'
import GrileService from '../services/grile-service'

const useGetFilters = () => {
  const [courses, setCourses] = useState([])
  const [chapters, setChapters] = useState([])
  const [coursesWithChapters, setCoursesWithChapters] = useState(null)

  const handleGetChaptersByCourse = useCallback(
    course => {
      if (coursesWithChapters === null) {
        return
      }
      return coursesWithChapters[course]?.map(chapter => chapter)
    },
    [coursesWithChapters],
  )

  useEffect(() => {
    const getAllTags = async () => {
      const response = await GrileService?.getAllFilters()
      const responseCourses = Object?.keys(response?.filters)
      const responseChapters = Object?.keys(response?.filters)?.map(
        course => response?.filters[course],
      )

      setCourses(responseCourses)
      setChapters(responseChapters?.flat())
      setCoursesWithChapters(response?.filters)
    }

    getAllTags()
  }, [])

  return { courses, chapters, coursesWithChapters, handleGetChaptersByCourse }
}

export default useGetFilters
